import { useUI } from '@/state/store';
import { useTwin } from '../store';

/** Recenter the current model or room without changing its display mode. */
export function resetModelView(): void {
  const twin = useTwin.getState();
  if (!twin.asset) return;
  twin.setHovered(null);
  useUI.getState().select({ subsystemId: null });
  twin.requestCamera({ poseId: twin.subviewId ?? 'main' });
}
